import { render, staticRenderFns } from "./mainLogout.vue?vue&type=template&id=a200ba04&"
import script from "./mainLogout.vue?vue&type=script&lang=js&"
export * from "./mainLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports